/* ============================================================
   GALIA · ficha y carrito en celular (20-oct-2026)
   1. Barra fija de compra visible desde el inicio (solo celular).
      Antes de tocar una talla, el botón dice "Elegir talla" y
      lleva al selector; después agrega al carro normalmente.
   2. WhatsApp: se esconde con el carro abierto o en /cart, y
      sube cuando la barra fija está visible.
   3. Navegador de Instagram/Facebook: el botón agregar hace un
      envío nativo a /cart/add (sin AJAX) y lleva al carro.
      Prueba en cualquier navegador con ?galia_iab=1 (se apaga con ?galia_iab=0)
   4. Página /cart en celular: "Finalizar compra" fijo abajo.
   ============================================================ */
(function () {
  if (window.__galiaFicha) return;
  window.__galiaFicha = true;

  var html = document.documentElement;

  /* ---------- 3. Detección de navegador dentro de apps ---------- */
  var ua = navigator.userAgent || '';
  var params = new URLSearchParams(location.search);
  try {
    if (params.get('galia_iab') === '1') sessionStorage.setItem('galia_iab', '1');
    if (params.get('galia_iab') === '0') sessionStorage.removeItem('galia_iab');
  } catch (e) {}
  var forced = false;
  try { forced = sessionStorage.getItem('galia_iab') === '1'; } catch (e) {}
  var IN_APP = forced || /Instagram|FBAN|FBAV|FB_IAB|FBIOS/i.test(ua);
  if (IN_APP) html.classList.add('galia-iab');

  if (location.pathname.replace(/\/$/, '').endsWith('/cart')) html.classList.add('galia-cart-page');

  /* ---------- 2. WhatsApp ---------- */
  function patchWhatsApp(el) {
    if (!el || el.__galiaPatched || !el.shadowRoot) return false;
    var st = document.createElement('style');
    st.textContent =
      '.gty-wacb-wrapper{bottom:var(--galia-wa-bottom,16px)!important;transition:bottom .2s ease}';
    el.shadowRoot.appendChild(st);
    el.__galiaPatched = true;
    return true;
  }
  function findWhatsApp() {
    var el = document.querySelector('gty-whatsapp-chat-button');
    if (el && !patchWhatsApp(el) && !el.__galiaPatched) {
      var tries = 0;
      var t = setInterval(function () {
        if (patchWhatsApp(el) || el.__galiaPatched || ++tries > 40) clearInterval(t);
      }, 250);
    }
    return !!el;
  }
  if (!findWhatsApp()) {
    var mo = new MutationObserver(function () {
      if (findWhatsApp()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* Carro abierto (respaldo por si el navegador no soporta :has) */
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var sync = function () { html.classList.toggle('galia-cart-open', d.hasAttribute('open')); };
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
    sync();
  }

  /* ---------- 1. Ficha: talla sin preseleccionar, barra fija, stock, envío ---------- */
  function scrollToPicker(picker) {
    if (!picker) return;
    var y = picker.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
    picker.classList.remove('galia-pulse');
    void picker.offsetWidth;
    picker.classList.add('galia-pulse');
  }

  function sizeFieldset(picker) {
    if (!picker) return null;
    var sets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      var txt = lg ? lg.textContent.toLowerCase() : '';
      if (/talla|size/.test(txt)) return sets[i];
    }
    return null;
  }

  /* El tema vuelve a pintar la columna de compra al cambiar de talla:
     por eso todo se busca de nuevo en cada actualización. */
  function q(sel) { return document.querySelector('.product-info ' + sel); }
  function mainForm() { return document.querySelector('.product-info form[action*="/cart/add"]'); }

  function initFicha() {
    if (!mainForm()) return;
    var bar = document.querySelector('product-sticky-bar');

    /* Barra fija visible mientras el botón principal no está en pantalla */
    var io = null, observed = null;
    if (bar) {
      html.classList.add('galia-sticky');
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.target === observed) html.classList.toggle('galia-atc-visible', en.isIntersecting);
          });
        }, { threshold: 0.4 });
      }
    }
    var watchButtons = function () {
      if (!io) return;
      var bb = q('buy-buttons');
      if (bb && bb !== observed) {
        if (observed) io.unobserve(observed);
        observed = bb;
        io.observe(bb);
      }
    };

    /* Aviso de stock bajo según la talla elegida */
    var currentVariantId = function () {
      try { var f = mainForm(); return f ? String(new FormData(f).get('id') || '') : ''; } catch (e) { return ''; }
    };
    var renderStock = function () {
      var el = q('[data-gf-stock]');
      if (!el) return;
      var map = {};
      try { var m = q('[data-gf-stock-map]'); if (m) map = JSON.parse(m.textContent || '{}'); } catch (e) {}
      var s = map[currentVariantId()];
      var txt = s && !html.classList.contains('galia-need-size') ? (s.q === 1 ? 'Queda 1' : 'Quedan ' + s.q) + ' en talla ' + s.t : '';
      if (el.textContent !== txt) el.textContent = txt;
      if (el.hidden !== !txt) el.hidden = !txt;
    };

    /* Tarjeta de envío: corte diario y cuenta regresiva, sin despacho domingo
       (misma regla que galia-material-envio). */
    var renderEnvio = function () {
      var box = q('[data-gf-envio]');
      if (!box) return;
      var head = box.querySelector('[data-gf-envio-head]');
      var sub = box.querySelector('[data-gf-envio-sub]');
      var counter = box.querySelector('[data-gf-envio-counter]');
      var time = box.querySelector('[data-gf-envio-time]');
      var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 12;
      var dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var set = function (el, txt) { if (el && el.textContent !== txt) el.textContent = txt; };
      var now = new Date();
      var hoy = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var corte = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
      var hoyValido = hoy.getDay() !== 0;
      if (hoyValido && now < corte) {
        set(head, 'Si compras ahora, llega hoy');
        set(sub, 'Pedido despachado el mismo día.');
        var diff = Math.floor((corte - now) / 1000);
        set(time, pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60));
        if (counter && counter.hidden) counter.hidden = false;
      } else {
        var d = new Date(hoy);
        do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0);
        set(head, 'Llega el ' + dias[d.getDay()] + ' ' + d.getDate());
        set(sub, hoyValido ? 'La hora de corte de hoy ya pasó.' : 'Hoy no realizamos despachos.');
        if (counter && !counter.hidden) counter.hidden = true;
      }
    };
    setInterval(renderEnvio, 1000);

    /* Tarjeta "Entre tejidos": tejidos en el carro según el cajón del carro
       (galia-tiers lo pinta el servidor en cada cambio del carro). */
    var tejidosEnCarro = function (box) {
      var t = document.querySelector('cart-drawer [data-gf-tejidos]');
      if (t) return parseInt(t.getAttribute('data-gf-tejidos'), 10) || 0;
      if (document.querySelector('cart-drawer')) return 0;
      return parseInt(box.getAttribute('data-n'), 10) || 0;
    };
    var renderTramo = function () {
      var box = q('[data-gf-tramo]');
      if (!box) return;
      var n = tejidosEnCarro(box);
      var step = n >= 2 ? 3 : n === 1 ? 2 : 1;
      var p2 = box.getAttribute('data-p2'), p3 = box.getAttribute('data-p3');
      var txt = n >= 2 ? 'Ya hay ' + n + ' tejidos en tu carro: este queda en ' + p3
        : n === 1 ? 'Ya hay un tejido en tu carro: este queda en ' + p2
        : 'Con un segundo tejido, este queda en ' + p2;
      var head = box.querySelector('[data-gf-tramo-head]');
      if (head && head.textContent !== txt) head.textContent = txt;
      Array.prototype.forEach.call(box.querySelectorAll('[data-step]'), function (s) {
        s.classList.toggle('is-on', parseInt(s.getAttribute('data-step'), 10) === step);
      });
    };
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () { setTimeout(renderTramo, 30); })
        .observe(drawer, { childList: true, subtree: true });
    }
    document.addEventListener('cart:change', function () { setTimeout(renderTramo, 300); });

    /* Aviso de arriba: baja a la tarjeta */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('[data-gf-hook]');
      if (!a) return;
      var box = q('[data-gf-tramo]');
      if (!box) return;
      e.preventDefault();
      window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });

    var refresh = function () { watchButtons(); renderStock(); renderEnvio(); renderTramo(); };
    var timer = null;
    var scheduleRefresh = function () { clearTimeout(timer); timer = setTimeout(refresh, 60); };
    var section = mainForm().closest('.shopify-section') || document.querySelector('main');
    if (section && 'MutationObserver' in window) {
      new MutationObserver(scheduleRefresh).observe(section, { childList: true, subtree: true });
    }
    document.addEventListener('variant:change', scheduleRefresh);

    /* Talla sin preseleccionar: solo si hay al menos 2 tallas disponibles */
    var fs = sizeFieldset(q('variant-picker'));
    var radios = fs ? fs.querySelectorAll('input[type="radio"]') : [];
    var enabled = Array.prototype.filter.call(radios, function (r) { return !r.disabled; });
    if (enabled.length >= 2) {
      html.classList.add('galia-need-size');
      Array.prototype.forEach.call(radios, function (r) { r.checked = false; });

      var markPicked = function () {
        if (!html.classList.contains('galia-need-size')) return;
        html.classList.remove('galia-need-size', 'galia-size-missing');
        scheduleRefresh();
        setTimeout(refresh, 500);
      };
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-info variant-picker')) markPicked();
      }, true);
      document.addEventListener('click', function (e) {
        var lab = e.target && e.target.closest && e.target.closest('.product-info variant-picker label');
        if (lab) markPicked();
      }, true);

      /* Botón principal o barra fija antes de elegir talla: llevar al selector.
         Se escucha en window (fase de captura) para adelantarse a cualquier listener del tema. */
      var askSize = function () {
        html.classList.add('galia-size-missing');
        scrollToPicker(q('variant-picker'));
      };
      window.addEventListener('click', function (e) {
        if (!html.classList.contains('galia-need-size')) return;
        var btn = e.target && e.target.closest && e.target.closest('product-sticky-bar button[type="submit"], .product-info buy-buttons button[type="submit"]');
        if (!btn) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        askSize();
      }, true);
      window.addEventListener('submit', function (e) {
        if (!html.classList.contains('galia-need-size')) return;
        if (e.target !== mainForm()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        askSize();
      }, true);
    }
    refresh();

    /* Enlace a reseñas */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('[data-gf-resenas]');
      if (!a) return;
      var target = document.querySelector('[id*="171986685889425477"]') ||
        document.querySelector('[class*="revie_reviews_por_whatsapp_app_block_2"]');
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
    });
  }

  /* ---------- 3. Envío nativo en Instagram/Facebook ---------- */
  function initInAppFallback() {
    if (!IN_APP) return;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      var fd = new FormData(form);
      if (!fd.get('id')) {
        var hidden = form.querySelector('input[name="id"]');
        if (hidden) hidden.disabled = false;
      }
      e.stopImmediatePropagation();
      e.stopPropagation();
    }, true);
  }

  /* ---------- 4. Página /cart: botón de pago siempre a mano ---------- */
  function initCartPageBar() {
    if (!html.classList.contains('galia-cart-page')) return;
    var getOriginal = function () { return document.querySelector('main [name="checkout"]'); };
    var original = getOriginal();
    if (!original) return;

    var bar = document.createElement('div');
    bar.className = 'galia-cart-bar';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button w-full';
    btn.textContent = (original.textContent || 'Finalizar compra').trim();
    btn.addEventListener('click', function () {
      var o = getOriginal();
      if (o) o.click();
    });
    bar.appendChild(btn);
    document.body.appendChild(bar);
    html.classList.add('galia-cart-bar-on');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          html.classList.toggle('galia-checkout-visible', en.isIntersecting);
        });
      }, { threshold: 0.6 });
      io.observe(original);
      // La sección del carro se vuelve a pintar al cambiar cantidades
      new MutationObserver(function () {
        var o = getOriginal();
        if (o && o !== original) { io.unobserve(original); original = o; io.observe(o); }
        html.classList.toggle('galia-cart-bar-on', !!o);
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }

  function boot() {
    watchDrawer();
    initFicha();
    initInAppFallback();
    initCartPageBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
